import { fetchUserAttributes, getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { createContext, useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import ErrorBoundary from '../Components/ErrorBoundary';
import { apiWithAuth } from '../Services/Axios/axios';
import { url_api_int_profile_details } from '../RoutesMap';

export const AuthContext = createContext({ currentUser: null, setCurrentUser: () => { }, fetchingUser: false });

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [fetchingUser, setFetchingUser] = useState(true);

  useEffect(() => {
    const pathname = window.location.pathname || '';
    if (!pathname.includes('/login')) {
      handleCheckUser();
    } else {
      setFetchingUser(false);
    }
  }, []);

  const handleCheckUser = async () => {
    setFetchingUser(true);
    try {
      await getCurrentUser();
      await fetchUserInfo();
      setFetchingUser(false);
    } catch (error) {
      if (error?.message === 'Access Token has been revoked' || error?.message === 'User is disabled.') {
        localStorage.removeItem('redirect_path');
        sessionStorage.clear();
        await signOut();
        setTimeout(() => {
          goToLogin();
        }, 1000);
      } else {
        goToLogin();
      }
    }
  }

  const goToLogin = async () => {
    const path = window.location.pathname + window.location.search;
    localStorage.setItem('redirect_path', path);
    try {
      await signInWithRedirect();
    } catch (error) {
      console.log(error);
    }
  }

  const fetchUserInfo = async () => {
    const userAttributes = await fetchUserAttributes();
    const response = await apiWithAuth.post(url_api_int_profile_details, {}, { headers: { "Content-Type": "multipart/form-data" } });
    if (response.data.status) {
      userAttributes['profile_image'] = response.data.data.user_profile_image;
    }
    setCurrentUser(userAttributes);
    return userAttributes;
  };

  if (fetchingUser) {
    return (
      <Box sx={{ width: '100svw', height: '100svh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress size={40} color="secondary" />
      </Box>
    )
  }

  return (
    <AuthContext.Provider value={{ currentUser, setCurrentUser, fetchingUser }}>
      <ErrorBoundary>
        {children}
      </ErrorBoundary>
    </AuthContext.Provider>
  );
};